<template>
  <DashboardBottomCardContent
    :callToActionButtonText="$t('L_update_your_debts')"
    @callToActionCallback="updateDebts"
  >
    <template #icon>
      <v-img
        :src="debtCalculatorIcon"
        alt="debtcalculator-icon"
        width="65"
        max-width="65"
        role="presentation"
        class="ma-0"
      />
    </template>
    <template #content>
      <h4 role="heading" aria-level="3" class="ml-6">
        <span id="title-h2" class="d-block font-weight-bold">{{
          $t('L_update_your_plan_to_see')
        }}</span>
        <span class="d-block font-weight-regular">{{ $t('L_debt_stacking_can_lead') }}</span>
      </h4>
    </template>
  </DashboardBottomCardContent>
</template>

<script lang="ts">
import { RouteNames } from '@/router/routeNames';
import { defineComponent } from 'vue';
import debtCalculatorIcon from '../assets/debt-calculator.svg';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { $t } from '@/i18n/i18n.ts';

export default defineComponent({
  name: 'DebtSolutionsV03Bottom',
  components: { DashboardBottomCardContent },
  data() {
    return { debtCalculatorIcon };
  },
  methods: {
    $t,
    async updateDebts(this: { $route: RouteLocationNormalizedLoaded; $router: Router }) {
      const route = this.$route;
      const router = this.$router;
      if (route.path !== '/debtsolutions/mydebt') {
        await router.push({ name: RouteNames.MY_DEBT });
      }
    },
  },
});
</script>
